import { Inject, Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UrlService } from '../state/url.service';
import { FacettenUrlService } from './facetten.url.service';

/**
 * Kombiniert die Url-Parameter der Facetten für den Backend-Request.
 */
@Injectable({ providedIn: 'root' })
export class CombinedFacettenUrlService {
  constructor(
    // eslint-disable-next-line @angular-eslint/prefer-inject
    private readonly urlService: UrlService,
    // eslint-disable-next-line @angular-eslint/prefer-inject
    @Inject(FacettenUrlService) private readonly facettenUrlServices: FacettenUrlService[]
  ) {}

  public combinedFacetteParameters$: Observable<{ param: string; ids: string[] }[]> = combineLatest(
    this.facettenUrlServices.map((service) =>
      service.selectedOptionIds$.pipe(
        map((ids) => ({
          param: service.backendParam,
          ids
        }))
      )
    )
  );

  /**
   * Lösche alle gesetzten Facetten-Parameter.
   */
  public async resetOptionSelections() {
    const params = {
      [UrlService.AKTUELLE_SEITE]: null,
      [UrlService.SELECTED_ANGEBOT]: null
    };
    this.facettenUrlServices.forEach((service) => (params[service.urlParam] = null));
    await this.urlService.updateView(params);
  }
}
